(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  const updateCwsShippingBanner = async () => {
    const banners = document.querySelectorAll('[data-cws-shipping-banner]');
    if (!banners.length) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const total = Number(cart.total_price);
      if (!Number.isFinite(total)) return;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency', currency: cart.currency || 'BRL'
      });
      for (const banner of banners) {
        const target = Number(banner.dataset.target);
        if (!Number.isFinite(target) || target <= 0) continue;
        const remaining = Math.max(0, target - total);
        const message = banner.querySelector('[data-cws-shipping-message]');
        const track = banner.querySelector('[data-cws-shipping-track]');
        if (message) {
          message.textContent = !cart.item_count ? banner.dataset.empty : remaining === 0
            ? banner.dataset.reached : banner.dataset.remainingTemplate.replace('__AMOUNT__', money.format(remaining / 100));
        }
        if (track) {
          const progress = Math.min(100, Math.max(0, Math.round(total * 100 / target)));
          track.setAttribute('aria-valuenow', String(progress));
          const fill = track.querySelector('span');
          if (fill) fill.style.width = `${progress}%`;
        }
      }
    } catch (_) {}
  };
  let cwsShippingUpdateTimer;
  const queueCwsShippingBannerUpdate = () => {
    clearTimeout(cwsShippingUpdateTimer);
    cwsShippingUpdateTimer = setTimeout(updateCwsShippingBanner, 350);
  };
  document.addEventListener('shopify:cart:lines-update', queueCwsShippingBannerUpdate);
  document.addEventListener('shopify:cart:discount-update', queueCwsShippingBannerUpdate);
  window.addEventListener('pageshow', updateCwsShippingBanner);
  document.addEventListener('shopify:section:load', updateCwsShippingBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
